import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private scrollableSubject = new BehaviorSubject<boolean>(false);
  scrollable$ = this.scrollableSubject.asObservable();

  setScrollable(value: boolean) {
    this.scrollableSubject.next(value);
  }
}
